var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-previous-video-form',{staticClass:"pt-previous-video-form__page",attrs:{"isEdit":_vm.is_edit,"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }